(() => {
  const initFreshPage = (root) => {
    if (!root || root.dataset.freshInitialized === 'true') return;
    root.dataset.freshInitialized = 'true';

    root.querySelectorAll('[data-fresh-quantity]').forEach((control) => {
      const input = control.querySelector('input');
      const minus = control.querySelector('[data-fresh-minus]');
      const plus = control.querySelector('[data-fresh-plus]');
      if (!input) return;

      const change = (amount) => {
        const min = Number(input.min || 1);
        const max = Number(input.max || 10);
        input.value = String(Math.min(max, Math.max(min, Number(input.value || 1) + amount)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };

      minus?.addEventListener('click', () => change(-1));
      plus?.addEventListener('click', () => change(1));
    });

    const revealItems = root.querySelectorAll('[data-fresh-reveal]');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.13, rootMargin: '0px 0px -6% 0px' });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }
  };

  const boot = () => document.querySelectorAll('[data-fresh-conversion-v4]').forEach(initFreshPage);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
